import React from 'react'
import router from "../images/Router.svg";
import Bandwidth from "../images/Bandwidth-Monitor.svg";
import enoc from "../images/eNOC.svg";
const  ServicesPopup=({ showmorePopup, closemorepopup}) =>{
    return (
          <div className={`modal-custom ${showmorePopup ? "open" : ""}`}>
            <div className="modal_dialog">
              <div className="modal_content manage_service">
                <div className="modal_header">
                  <h5>Managed Services</h5>
                  <span className="close_icon bottom" onClick={closemorepopup}>
                <span></span>
                <span></span>
                <span></span>
              </span>
                </div>
                <div className="modal_body">
                  <p>We provide services that includes-</p>
                  <ul className="services_items">
                    <li>
                      <div className="info-content">
                        <strong>
                      <span className="icon">
                        <img src={router} alt="Router" />
                      </span>
                          Router Hardware
                        </strong>
                        <p>
                          Router that support auto-troubleshooting to fix
                          issues aplenty
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="info-content">
                        <strong>
                      <span className="icon">
                        <img src={Bandwidth} alt="Router" />
                      </span>
                          Bandwidth Monitor Widget
                        </strong>
                        <p>
                          Proactive network monitoring to identify and address network
                          issues before they happen
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="info-content">
                        <strong>
                      <span className="icon">
                        <img src={enoc} alt="Router" />
                      </span>
                          e-NOC Managed Service
                        </strong>
                        <p>
                          e-Noc Managed Service: Service availability backed by our industry-leading
                          SLAs and 24X7 support
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
    )
}

export default ServicesPopup
